module.exports = __webpack_public_path__ + "static/media/fruit-market.1da3919a.jpg";